<template>
  <div class="interval"></div>
</template>

<script>
// 边界线
export default {
  name: 'MarginLine'
}
</script>

<style lang="scss" scoped>
.interval {
  width: 100%;
  height: .16rem;
  background-color: #F7F9FB;
}
</style>